import { EmailVariablesViewModel } from './email-variables.viewmodel';
import { withViewModel } from '../../../infrastructure/components/with-view-model';
import { EmailVariablesSectionPresentation } from './email-variables-presentation';
import { EMAIL_LIST_TYPE } from '../../../constants/email-variables.constants';
import './email-variables.scss';

interface IProps {
    type: EMAIL_LIST_TYPE;
}

const EmailVariablesSection = withViewModel(EmailVariablesSectionPresentation, (props: IProps) => {
    return new EmailVariablesViewModel(props.type);
});

export { EmailVariablesSection };
